// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__k_L_H"};